import { render, staticRenderFns } from "./NuevoExpediente.vue?vue&type=template&id=4f4d50fd&scoped=true&"
import script from "./NuevoExpediente.vue?vue&type=script&lang=js&"
export * from "./NuevoExpediente.vue?vue&type=script&lang=js&"
import style0 from "./NuevoExpediente.vue?vue&type=style&index=0&id=4f4d50fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d50fd",
  null
  
)

export default component.exports